export var DEFAULT_WAVE_COLOR = '#30AEF2';
export var NO_VIDEO_GREY_BG = "#eef0f6";
export var WAVE_BLACK_COLOR = '#292A2B';
export var DEFAULT_STUDIO_BG = '#adcbe3';